export class NotableActivityOption {
  Id?: number;
  RecordId?: number;
  ProjectId: number;
  LaborCategoryId: number;
  Name: string;
  IsDeleted: boolean;

  constructor(obj?: Partial<NotableActivityOption>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  clone(): NotableActivityOption {
    return Object.assign(new NotableActivityOption(), this);
  }

  setName(name: string): void {
    this.Name = name;
  }

  setProjectId(projectId: number): void {
    this.ProjectId = projectId;
  }

  setLaborCategoryId(laborCategoryId: number): void {
    this.LaborCategoryId = laborCategoryId;
  }

  setSoftDeleted(): void {
    this.IsDeleted = true;
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
